// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Hb4cO","colBig":"styles_colBig__1ANse","colSmall":"styles_colSmall__2nD3I"};